import { FormTabs, Button } from 'shared/components'
import { FormProps } from './types'
import { cn } from 'utils/style'

const primaryButton =
	'h-9 rounded-md px-4 text-sm font-medium shadow transition-colors hover:bg-primary/90'
const outlineButton =
	'h-9 rounded-md border border-border bg-background px-4 text-sm font-medium text-foreground shadow hover:bg-muted'

export const Form = ({
	children,
	variant = 'default',
	submitText,
	secondSubmitText,
	cancelText,
	actions,
	startActions,
	tabs,
	activeTab,
	className,
	isLoading,
	disabled,
	hideBorderTop = false,
	setActiveTab,
	onSubmit,
	onCancel,
	setValue
}: FormProps) => {
	if (variant === 'sections') {
		return (
			<form
				onSubmit={onSubmit}
				className={cn('mx-auto flex w-full max-w-[704px] flex-col gap-5', className)}>
				{children}
				{(!disabled || startActions) && (
					<div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
						{startActions && <div className="sm:mr-auto">{startActions}</div>}
						{!disabled && (
							<>
								{actions}
								{cancelText && (
									<Button styleType="outline" className={outlineButton} onClick={onCancel}>
										{cancelText}
									</Button>
								)}
								{secondSubmitText && (
									<Button
										type="submit"
										styleType="outline"
										isLoading={isLoading}
										className={outlineButton}
										onClick={() => setValue && setValue('action', 'submit-stay')}>
										{secondSubmitText}
									</Button>
								)}
								{submitText && (
									<Button
										type="submit"
										isLoading={isLoading}
										className={primaryButton}
										onClick={() => setValue && setValue('action', 'submit-redirect')}>
										{submitText}
									</Button>
								)}
							</>
						)}
					</div>
				)}
			</form>
		)
	}

	if (variant === 'card') {
		return (
			<form onSubmit={onSubmit} className={cn('w-full max-w-2xl', className)}>
				<div className="rounded-xl border border-border bg-card p-5 shadow-panel sm:p-7">
					<div className="grid gap-5">{children}</div>
					{submitText && !disabled && (
						<Button
							type="submit"
							isLoading={isLoading}
							className={cn(primaryButton, 'mt-7 w-full font-display font-semibold')}>
							{submitText}
						</Button>
					)}
				</div>
			</form>
		)
	}

	return (
		<form
			onSubmit={onSubmit}
			className={cn('mx-auto mt-8 flex w-full max-w-lg flex-col gap-4 lg:mx-0 lg:mt-5', className)}>
			{tabs && <FormTabs tabs={tabs} changeTab={setActiveTab} activeTab={activeTab!} />}
			<div
				className={cn(
					'flex flex-col gap-4 bg-white px-4 pb-5 pt-2.5',
					hideBorderTop
						? 'border border-t-0 border-seashell'
						: 'border-t-4 border-malibu shadow-[0_1px_4px_rgba(0,0,0,0.12)]'
				)}>
				{children}
				<div className="flex flex-col gap-2 sm:flex-row">
					{submitText && !disabled && (
						<Button
							type="submit"
							isLoading={isLoading}
							className="flex-1 rounded-lg p-2.5 px-2"
							onClick={() => setValue && setValue('action', 'submit-redirect')}>
							{submitText}
						</Button>
					)}
					{secondSubmitText && !disabled && (
						<Button
							type="submit"
							isLoading={isLoading}
							className="flex-1 rounded-lg p-2.5 px-2"
							onClick={() => setValue && setValue('action', 'submit-stay')}>
							{secondSubmitText}
						</Button>
					)}
				</div>
			</div>
		</form>
	)
}
